<style>
    .cplp_login-section .container {
        background: white;
        padding: 50px 20px;
        max-width: 700px;
    }

    .cplp_login-section input[type="password"] {
        background: #f5faff;
        max-width: 400px;
        width: 100%;
        height: 40px;
        margin: 0 auto;
        border: 2px solid #4C9AFF;
    }

    .cplp_login-section input[type="password"]:focus {
        border: 2px solid #000;
        outline: none;
        box-shadow: none;
    }

    .cplp_login-section input[type="submit"] {
        max-width: 400px;
        width: 100%;
        height: 40px;
        font-family: Open Sans;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        background: #253858;
        border-radius: 3px;
        margin-top: 0;
        box-shadow: none;
    }

    .cplp_login-submit {
        margin-top: 0;
    }

    img.logo {
        width: auto;
        margin: 0 auto 30px;
    }

    @media only screen and (max-width: 767px) {
        .cplp_login-section {

            padding: 0px !important;

        }

        .cplp_login-body {
            background-color: #fff !important;
        }
    }

    .cplp_login-section input[type="submit"]:hover {
        background: #253858c9;
        text-decoration: inherit;
        transition-duration: 0s, 0.15s;
        color: var(--ds-text-inverse, #FFFFFF) !important;
    }

    .cplp_login-create {
        text-align: center;
        margin-top: 30px;
        color: #364655;
    }

    .cplp_login-forgot a,
    .cplp_login-activate a,
    .cplp_login-create a {
        color: #364655;
    }
</style>
<div style="background-color: rgb(245, 250, 255);" [ngStyle]="{'height': isPopup ? '100%' : '100vh'}" class="cplp_login-body" [@routerTransition]>
    <div class="wrapper" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
        <div id="cplp_login_main" class="cplp_login_main" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
            <div class="cplp_login-section" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
                <div class="container" [ngStyle]="{'height': isPopup ? '100%' : 'auto'}">
                    <div class="row align-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="cplp_login-intro">
                                <img *ngIf="!isPopup" src="/assets/anonymouspage/images/logo.png" alt="" class="logo"
                                    style="padding-left : 0px" />
                                <h2> {{l('SendSecurityCode')}}</h2>
                            </div>
                            <div class="contact-form wow fadeInDown">
                                <form #twoFactorForm="ngForm" class="m-login__form m-form" method="post"
                                    (ngSubmit)="submit()">
                                    <div class="controls">
                                        <div class="row">
                                            <!-- <div class="col-md-3"></div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <p>{{l('SendSecurityCode')}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-2"></div> -->


                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <select autoFocus style="margin: auto; max-width: 400px;" size="1"
                                                        class="form-control" [(ngModel)]="selectedTwoFactorProvider"
                                                        name="selectedTwoFactorProvider">
                                                        <option
                                                            *ngFor="let provider of loginService.authenticateResult.twoFactorAuthProviders"
                                                            [value]="provider">{{provider}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row cplp_login-submit">
                                            <div class="col-md-12">

                                                <!-- <button [disabled]="saving" routerLink="/login" type="button" class="cplp_btn-action cplp_btn-action-primary"><i class="fa fa-arrow-left"></i> {{l("Back")}}</button> -->
                                                <!-- <button type="submit" class="cplp_btn-action cplp_btn-action-primary" [disabled]="!resetPassForm.form.valid" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')">{{l("Submit")}}</button> -->
                                            </div>
                                        </div>
                                        <div class="row cplp_login-submit">


                                            <div class="col-md-12">
                                                <input type="submit" class="buttonclass" [buttonBusy]="submitting"
                                                    [busyText]="l('SavingWithThreeDot')" value="SUBMIT">
                                            </div>

                                        </div>

                                        <div class="row cplp_login-register">
                                            <div class="col-md-3"></div>
                                            <div class="col-md-6 cplp_login-create mb-3">
                                                <a (click)="returnToLogin()">Return to log in</a>
                                            </div>
                                            <div class="col-md-3"></div>
                                        </div>
                                        <hr *ngIf="!isPopup">
                                        <div *ngIf="!isPopup" class="row cplp_login-footer">
                                            <div class="col-md-3"></div>
                                            <div class="col-md-6 mt-3">
                                                <img class="cplp_login-logo"
                                                    src="/assets/anonymouspage/images/Elek-Footer.png"
                                                    alt="Electrotechnik Pty Ltd">
                                                <p>For more information, visit <a href="https://elek.com"
                                                        target="_blank">elek.com</a></p>
                                            </div>
                                            <div class="col-md-3"></div>
                                        </div>
                                    </div>

                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>